import * as React from "react";
import {observer} from "mobx-react";
import {injectIntl, InjectedIntlProps, FormattedMessage} from "react-intl";
import {dataStore} from "src/models/DataStore";
import * as moment from "moment";
import {
    Chart,
    LineAdvance,
} from "bizcharts";
import "./DosageReport.less";
import {consoleApi, WhiteboardEnum} from "src/apiMiddleware";
import {IReactionDisposer, reaction} from "mobx";
import {message} from "antd";
import {LoadingOutlined} from "@ant-design/icons/lib";
import SwitchRegion from "../../SwitchRegion";

export type WhiteboardDataProps = InjectedIntlProps;
export type WhiteboardDataStates = {
    dataArray: any[];
    isMaskLoading: boolean;
};

@observer
class DosageReportChart extends React.Component<WhiteboardDataProps, WhiteboardDataStates> {
    private readonly reactionDateDisposer: IReactionDisposer;

    public constructor(props: WhiteboardDataProps) {
        super(props);
        this.reactionDateDisposer = this.startDateReaction();
        this.state = {
            dataArray: [],
            isMaskLoading: false,
        };
    }

    private startDateReaction(): IReactionDisposer {
        return reaction(() => {
            return dataStore.dosageMonth;
        }, async date => {
            await this.handleSelectMonth(date);
        });
    }

    public async componentDidMount(): Promise<void> {
        try {
            this.setState({isMaskLoading: true});
            const timestamp = new Date().getTime();
            const endDay = moment(timestamp).startOf("day").valueOf();
            const startDay = moment(timestamp).startOf("month").valueOf();
            const resp = await consoleApi.data.getWhiteboardData(startDay, endDay, WhiteboardEnum.team);
            if (resp.code === 200) {
                this.setState({dataArray: resp.data.result, isMaskLoading: false});
            }
        } catch (err) {
            message.error(err.message);
            this.setState({isMaskLoading: false});
        }
    }

    private handleSelectMonth = async (date: any): Promise<void> => {
        const todayTimestamp = new Date().getTime();
        if (moment(date).isSame(todayTimestamp, "month")) {
            const timestamp = new Date().getTime();
            const endDay = moment(timestamp).startOf("day").valueOf();
            const startDay = moment(timestamp).startOf("month").valueOf();
            if (endDay && startDay) {
                await dataStore.getTeamWhiteboardData(startDay, endDay);
            }
        } else {
            const endDay = moment(date).endOf("month").valueOf();
            const startDay = moment(date).startOf("month").valueOf();
            if (endDay && startDay) {
                await dataStore.getTeamWhiteboardData(startDay, endDay);
            }
        }
    }

    private renderTotalChart = (): React.ReactNode => {
        const {intl} = this.props;
        const totalDataSource = this.state.dataArray.map((data, index) => {
            return {
                key: `date-total-${index}`,
                date: moment(data.timestamp).format("MMM Do"),
                duration: data.totalDuration,
                type: intl.formatMessage({id: "total-duration"}),
            };
        });
        const readonlyDuration = this.state.dataArray.map((data, index) => {
            return {
                key: `date-readonly-${index}`,
                date: moment(data.timestamp).format("MMM Do"),
                duration: data.readonlyDuration,
                type: intl.formatMessage({id: "readonly-duration"}),
            };
        });
        const writableDataSource = this.state.dataArray.map((data, index) => {
            return {
                key: `date-writable-${index}`,
                date: moment(data.timestamp).format("MMM Do"),
                duration: data.writableDuration,
                type: intl.formatMessage({id: "interactive-duration"}),
            };
        });
        const dataSource = [...totalDataSource, ...readonlyDuration, ...writableDataSource];
        if (totalDataSource.length > 0) {
            return (
                <Chart autoFit
                       padding={[20, 120, 96, 120]}
                       width={1200}
                       height={300}
                       data={dataSource}>
                    <LineAdvance
                        shape="smooth"
                        point
                        area
                        position="date*duration"
                        color={["type", ["#3381FF", "#3DC797", "red"]]}
                    />
                </Chart>
            );
        } else {
            return null;
        }
    }

    private renderMask = (): React.ReactNode => {
        if (this.state.isMaskLoading) {
            return (
                <div className="content-box-mask">
                    <LoadingOutlined style={{fontSize: 36, color: "#3381FF"}}/>
                </div>
            );
        } else {
            return null;
        }
    }

    public render(): React.ReactNode {
        return (
            <div className="product-center-box">
                <div className="portal-room-outbox">
                    <div className="portal-room-chart-measure">
                        {this.renderMask()}
                        <div style={{ paddingLeft: 32 }}>
                            <SwitchRegion onChange={() => this.componentDidMount()} />
                        </div>
                        <div className="portal-room-box-mid">
                            <div className="console-content-chart-body">
                                <div className="console-content-chart-box">
                                    <div className="console-content-text">
                                        <FormattedMessage id={"total-duration"}/>
                                    </div>
                                    {this.renderTotalChart()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default injectIntl(DosageReportChart);





// WEBPACK FOOTER //
// ./src/components/portal/dataCenter/DosageReportChart.tsx